import {
  Component,
  OnInit,
  OnDestroy, Input, Output, EventEmitter, ElementRef, ViewChild
} from '@angular/core';

import { CookiesConsentService } from '../consent/consent.service';

@Component({
  selector: 'jb-cookies-consent',
  templateUrl: './consent.component.html',
  styleUrls: [
    './consent.component.scss'
  ]
})
export class CookiesConsentComponent implements OnInit {
  public localeParams: any;
  public display: boolean = true;

  @Output('isVisible')
  public isVisible: EventEmitter<boolean> = new EventEmitter<boolean>();

  @ViewChild('consentWrapper')
  public consentWrapper: ElementRef;

  constructor(private cookiesConsentService: CookiesConsentService) {
  }

  public ngOnInit() {
    this.cookiesConsentService.determineVisibility();

    this.cookiesConsentService
      .visibility
      .subscribe(
        (isVisible) => {
          if (isVisible !== null) {
            this.display = isVisible;

            this.isVisible.emit(this.display);
          }
        }
      );
  }

  public handleAccept($event) {
    $event.preventDefault();

    this.cookiesConsentService.accept();

    this.handleClose();
  }

  public handleClose() {
    this.cookiesConsentService.close();
  }

  public getHeight() {
    return this.consentWrapper.nativeElement.offsetHeight;
  }
}



// WEBPACK FOOTER //
// ./src/app/cookies/consent/consent.component.ts